import './contact.scss';
import { setupLayout } from '../Shared/layout';
import { setupEnquiryForm, EnquiryFormType } from '../Shared/Component/EnquiryForm/enquiry-form';
import { setupGoogleMap } from '../../src/module/google-map';
import { appConfig } from '../../src/appConfig';

setupLayout();
setupEnquiryForm(EnquiryFormType.General);

setupGoogleMap({
    apiKey: appConfig.googleMapApiKey,
    languageIsoCode: (document.getElementById('inputHiddenForPageLanguageIsoCode') as HTMLInputElement).value,
    styles: appConfig.googleMapStyles
});


// track
document.querySelectorAll<HTMLLinkElement>('.js-phoneLink').forEach(el => {
    el.addEventListener('click', () => {
        gtag('event', 'call', {
            send_to: appConfig.googleAnalyticsId,
            event_category: 'engagement',
            event_label: 'Taman Molek'
        });
        gtag('event', 'generate_lead', {
            send_to: appConfig.googleAnalytics4Id
        });
        gtag('event', 'call', {
            send_to: appConfig.googleAnalytics4Id,
            branch: 'Taman Molek'
        });
        fbq('track', 'Contact');
    });
});

document.querySelector<HTMLLinkElement>('#js-locationLink').addEventListener('click', () => {
    gtag('event', 'find_location', {
        send_to: appConfig.googleAnalyticsId,
        event_category: 'engagement',
        event_label: 'Taman Molek'
    });
    gtag('event', 'generate_lead', {
        send_to: appConfig.googleAnalytics4Id
    });
    gtag('event', 'find_location', {
        send_to: appConfig.googleAnalytics4Id,
        branch: 'Taman Molek'
    });
    fbq('track', 'FindLocation');
});

document.querySelector<HTMLLinkElement>('#js-emailLink').addEventListener('click', () => {
    gtag('event', 'email', {
        send_to: appConfig.googleAnalyticsId,
        event_category: 'engagement'
    });
    gtag('event', 'generate_lead', {
        send_to: appConfig.googleAnalytics4Id
    });
    gtag('event', 'email', {
        send_to: appConfig.googleAnalytics4Id
    });
    fbq('track', 'Contact');
});